// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
	currentEnvironment:"wobbly",//wobbly/stageUS/productionUS/stageEU/productionEU
	LDKeyWobbly:"5d9660f50c2ad708a49a0110",
	LDKeyStageUS:"5f15de5fda54e70bb79c6386",
	LDKeyProdUS:"6488170a3f8d3a13a5f4bde0",
	LDKeyStageEU:"5f15de71797a680b05ae20a0",
	LDKeyProdEU:"5f15de448fbbeb0bb172456c",
	production: false,
};
